import { render, staticRenderFns } from "./DetailsOrderCockpitPage.vue?vue&type=template&id=42c659e0&v-if=order&"
import script from "./DetailsOrderCockpitPage.vue?vue&type=script&lang=js&"
export * from "./DetailsOrderCockpitPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports